// FIRST: capture the browser's fetch before ./store wraps it (see the module).
import "./utils/pristine-fetch";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import store from "./store";
import "./index.css";
import "./styles/clinical-slate-type.css";
import "./styles/design-tokens-r1.css";
import App from "./App";
import { isClinicalSlateSkin } from "./constants/skin-flag";
import manifest from "./constants/clinical-slate-manifest.json";

// MUI v4's palette machinery (getContrastText, lighten/darken augmentation) cannot
// parse CSS `var(--…)` strings, so the role indirection is applied here as a
// JS-level flag read at theme-creation time (contract C2, gate finding S1) rather
// than a CSS passthrough. The OUTCOME is byte-fixed by the contract:
//
//   DEFAULT scope (skin flag off — the only customer-reachable state): byte-identical
//     to the pre-PR palette. MUI's default `primary` (#3f51b5-era indigo) is left
//     untouched; `secondary` points at the brand blue #2851bf (its shipped value),
//     because MUI's default secondary magenta/pink (#f50057) clashed with the blue
//     brand — every `color="secondary"` element rendered off-brand pink.
//   SKIN scope (Clinical Slate, staging-only): palette.primary resolves to the
//     `primary` role (one indigo #2A418F), retiring the #3f51b5 default and the
//     #2851bf secondary drift (tokens v1 §1 "ONE indigo").
function clinicalSlatePalette() {
    const primaryMain = manifest.colorRoles.find((r) => r.webKey === "primary").light;
    return { primary: { main: primaryMain }, secondary: { main: primaryMain } };
}

const theme = createTheme({
    palette: isClinicalSlateSkin() ? clinicalSlatePalette() : { secondary: { main: "#2851bf" } },
    // S4 (design-uplift r1): sentence-case chrome. MUI v4 uppercases button and
    // tab labels by default, which clashes with the sentence-case peer controls
    // and drives the 16e label wraps (CLEAR ALL / END QUIZ). Turn the transform
    // off globally; labels render as authored.
    overrides: {
        MuiButton: { root: { textTransform: "none" } },
        MuiTab: { root: { textTransform: "none" } },
    },
});

ReactDOM.render(<Provider store={store} >
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>
</Provider>,
    document.getElementById("root")
);
